import React from 'react'
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

export default function Counter({count, increment, decrement}) {

  return (
      <div className="counter">
          <IconButton aria-label="increment" onClick={increment}>
              <AddIcon />
          </IconButton>
          <p>{count}</p>
          <IconButton aria-label="decrement" onClick={decrement}>
              <RemoveIcon />
          </IconButton>
      </div>
  );
}
